import L from "leaflet";
import { Marker } from "react-leaflet";
import { Ferry } from "../../../services/RuteplanAPI";
import fergeIconResource from "../../../assets/ferry.svg"
import { useRouteFeatureDialogStoreActions } from "../../../stores/RouteFeatureDialogStore";

const fergeIcon = L.icon({
    iconUrl: fergeIconResource,
    iconRetinaUrl: fergeIconResource,
    iconAnchor: [14, 28],
    iconSize: [28, 28]
  });

export interface IFergeMarkersProps {
    ferger: Array<Ferry>;
}

export default function FergeMarkers (props: IFergeMarkersProps) {
    const { setClickedRoadFeature, setRoadFeatureDialogIsOpen } = useRouteFeatureDialogStoreActions();

    const { ferger } = props;

    return (
        <>
            {ferger.map((ferge: Ferry, index: number) => {
                return (
                    <Marker key={ferge.navn + index} 
                    position={[ferge.location!.y, ferge.location!.x]} 
                    icon={fergeIcon}
                    eventHandlers={{
                        click: () => {
                            setClickedRoadFeature(ferge);
                            setRoadFeatureDialogIsOpen(true);
                        }
                    }}
                    />
                )
            })}
        </>
    )
}